import React from "react";
import { OneTickField } from "@codway-dev/ui";
import { mapOneTickResolvedDataToFieldProps } from "@codway-dev/shared";
import { useShopCurrency } from "../../../hooks/useShopCurrency";
import type { UpsellEmbedPreviewProps } from "./types";

const NOOP = () => {};

export const OneTickEmbedPreview: React.FC<UpsellEmbedPreviewProps> = ({
  resolvedData,
}) => {
  const { formatPrice } = useShopCurrency();
  if (!resolvedData) return null;

  const props = mapOneTickResolvedDataToFieldProps(resolvedData, formatPrice);
  if (!props) return null;

  return <OneTickField {...props} selected={false} onToggle={NOOP} />;
};
